import React from "react";
import { MainNavigation } from "../ui/MainNavigation";
import { Breadcrumbs } from "../ui/breadcrumbs";

/**
 * MainLayout component
 *
 * Wraps content pages with consistent navigation and layout
 */
const MainLayout = ({ children, breadcrumbs = [] }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <MainNavigation />

      <main className="flex-1 container mx-auto py-4 px-4">
        {breadcrumbs.length > 0 && (
          <div className="mb-6">
            <Breadcrumbs items={breadcrumbs} />
          </div>
        )}

        {children}
      </main>

      <footer className="py-4 px-6 bg-muted text-center text-sm text-muted-foreground">
        <p>Bitbucket Variable Manager &copy; {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
};

export { MainLayout };
